/* eslint-disable import/no-cycle */
import {
  setCustomer,
	setPermissionDefinitions,
	setIsLoadingLoadedPermissionDefinitions,
	setHasLoadingErrorPermissionDefinitions
} from './actions';
import { ROOT_SLICE } from './constants';
import {
	selectThisSlice,
	selectIsLoadingPermissionDefinitions,
	selectIsLoadedPermissionDefinitions,
	selectHasLoadingErrorPermissionDefinitions
} from './selectors';

const isDefined = v => v !== undefined && v !== null;

// ************
// PARTS
// ************
const reducerParts = {
  [setCustomer]: (state, { payload: { customer } }) => { 
		const slice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...slice,
				customer
			}
		};
  },
	[setPermissionDefinitions]: (
		state,
		{
			payload: {
				permissionDefinitions,
				mapPermissionsByGroupName,
				listPermissionDefinitions,
				mapPermissionsListByAppKey
			}
		}
	) => {
		const slice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...slice,
				permissionDefinitions,
				mapPermissionsByGroupName,
				listPermissionDefinitions,
				mapPermissionsListByAppKey
			}
		};
	},

	[setHasLoadingErrorPermissionDefinitions]: (
		state,
		{ payload: { hasError } }
	) => {
		const slice = selectThisSlice(state);
		const currentHasError = selectHasLoadingErrorPermissionDefinitions(state);

		if (hasError === currentHasError) {
			return state;
		}

		return {
			...state,
			[ROOT_SLICE]: {
				...slice,
				hasLoadingErrorPermissionDefinitions: hasError
			}
		};
	},

	[setIsLoadingLoadedPermissionDefinitions]: (
		state,
		{
			payload: {
				isLoadingPermissionDefinitions: newIsLoadingPermissionDefinitions,
				isLoadedPermissionDefinitions: newIsLoadedPermissionDefinitions
			}
		}
	) => {
		const slice = selectThisSlice(state);
		const isLoadingPermissionDefinitions = selectIsLoadingPermissionDefinitions(
			state
		);
		const isLoadedPermissionDefinitions = selectIsLoadedPermissionDefinitions(
			state
		);

		const isLoadingChanged =
			isDefined(newIsLoadingPermissionDefinitions) &&
			newIsLoadingPermissionDefinitions !== isLoadingPermissionDefinitions;
		const isLoadedChanged =
			isDefined(newIsLoadedPermissionDefinitions) &&
			newIsLoadedPermissionDefinitions !== isLoadedPermissionDefinitions;

		if (!isLoadingChanged && !isLoadedChanged) {
			return state;
		}

		return {
			...state,
			[ROOT_SLICE]: {
				...slice,
				isLoadingPermissionDefinitions: isLoadingChanged
					? newIsLoadingPermissionDefinitions
					: isLoadingPermissionDefinitions,
				isLoadedPermissionDefinitions: isLoadedChanged
					? newIsLoadedPermissionDefinitions
					: isLoadedPermissionDefinitions
			}
		};
	}
};

export default reducerParts;
